import { useEffect } from "react";
import { useAuth } from "../authContext";
import { useSecurity } from "../SecurityContext";

const BODY_CLASS = "allow-text-selection";
const RESOURCE_KEY = "ui.textselection";
const RESOURCE_ACTION = "execute";

export default function TextSelectionBypass() {
  const { isLoggedIn } = useAuth();
  const {
    subjectHasPermission,
    permissionsVersion,
    loading,
    isViewAsActive,
    viewAsLoading,
  } = useSecurity();

  useEffect(() => {
    if (!isLoggedIn || loading || (isViewAsActive && viewAsLoading)) {
      document.body.classList.remove(BODY_CLASS);
      return undefined;
    }

    const allowed = subjectHasPermission(RESOURCE_KEY, RESOURCE_ACTION);
    document.body.classList.toggle(BODY_CLASS, allowed);

    return () => {
      document.body.classList.remove(BODY_CLASS);
    };
  }, [
    isLoggedIn,
    loading,
    isViewAsActive,
    viewAsLoading,
    permissionsVersion,
    subjectHasPermission,
  ]);

  return (
    <span
      className="display-none"
      data-resource={RESOURCE_KEY}
      data-action={RESOURCE_ACTION}
      data-description="Allow text selection on pages"
      aria-hidden="true"
    />
  );
}
